import React, { Component } from 'react';
import * as Http from '../../http'
import * as Business from '../../utils/business'
import Loading from '../../components/Loading'
import { MenuItem, DropdownButton } from 'react-bootstrap';

export default class OtherAsset extends Component {
  constructor(props) {
    super(props);
    this.type = props.type;
    this.state = {
      loading: true,
      data: [],
      dataOld: [],
      showDeleteAlert: false
    }
    this.usernameWillDelete = null
  }

  componentDidMount() {
    this.getListMasterTables()
  }

  getListMasterTables = () => {
    this.setState({
      loading: false
    })
    Http.getMasterTableByType(this.type)
      .then(res => {
        const data = [];
        if (res && res.Data) {
          var lstData = Array.isArray(res.Data) ? res.Data.sort((a, b) => a.TimeChanged.localeCompare(b.TimeChanged)) : [];
          var lastIndex = lstData.length - 1;
          for (let index = 0; index < lstData.length; index++) {
            const element = res.Data[index];
            var obj = element;
            obj.Index = index;
            if (index != lastIndex) {
              obj.IsLastItem = false;
            } else {
              obj.IsLastItem = true;
            }
            data.push(obj);
          }
        }
        if (this.type == 5) {
          if (data.length == 0) {
            var obj = {
              Index: 0,
              IsLastItem: true,
              Name: 'DEFAULT',
              Type: this.type,
              Value: 'DEFAULT'
            }
            data.push(obj);
          }
        }
        this.setState({
          loading: false,
          data: data,
          dataOld: data
        })
      })
  }

  onValidate = (lstData) => {
    const dicCheckNameExist = {};
    // Check ban ghi ton tai
    for (let i = 0; i < lstData.length; i++) {
      const obj = lstData[i];
      if (dicCheckNameExist.hasOwnProperty(obj.Name)) {
        return `${obj.Name} record already exists`;
      }
      if (!obj.Name) {
        return `'Name' must not be null`;
      }
      dicCheckNameExist[obj.Name] = obj.Name;
    }
    return null;
  }

  onUpdateData = () => {
    const errorMsg = this.onValidate(this.state.data);
    if (errorMsg) {
      Business.showAlert({
        title: 'Error',
        content: errorMsg
      })
      return;
    }

    this.setState({
      loading: true
    }, () => {
      const listData = [];
      for (let i = 0; i < this.state.data.length; i++) {
        const obj = this.state.data[i];
        const newObj = { Name: obj.Name, Value: obj.Value, Type: this.type }
        listData.push(newObj)
      }
      Http.updateMasterTable(listData, this.type)
        .then(res => {
          this.getListMasterTables();
        })
    })
  }

  onCancel = () => {
    this.setState({
      data: this.state.dataOld
    });
  }

  onAddItem = (index) => {
    const data = JSON.parse(JSON.stringify(this.state.data));

    data.splice(
      index + 1,
      0,
      {
        Name: 'DEFAULT',
        Value: 'DEFAULT',
        Type: this.type
      }
    );

    const lstData = [];
    const lastIndex = data.length - 1;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var obj = element;
      obj.Index = index;
      if (index != lastIndex) {
        obj.IsLastItem = false;
      } else {
        obj.IsLastItem = true;
      }
      lstData.push(obj);
    }
    this.setState({ data: lstData });
  }

  onRemoveItem = (index) => {
    const data = JSON.parse(JSON.stringify(this.state.data));
    if (index > -1) {
      data.splice(index, 1);
    }
    const lstData = [];
    const lastIndex = data.length - 1;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var obj = element;
      obj.Index = index;
      if (index != lastIndex) {
        obj.IsLastItem = false;
      } else {
        obj.IsLastItem = true;
      }
      lstData.push(obj);
    }
    this.setState({ data: lstData });
  }

  handleSelectAssetCode = (index, eventKey, event) => {
    const data = JSON.parse(JSON.stringify(this.state.data));
    if (eventKey == 'DEFAULT') {
      const obj = data[index];
      obj.Name = 'DEFAULT';
      obj.Value = 'DEFAULT';
      data[index] = obj;
    } else {
      const obj = data[index];
      obj.Value = eventKey;
      data[index] = obj;
    }
    this.setState({ data });
  }

  renderRow = (index, isLastItem) => {
    const classNameAddLessIcon = isLastItem ? 'pe-7s-plus' : 'pe-7s-less';
    const classNameAddIcon = 'pe-7s-plus';
    const classNameLessIcon = 'pe-7s-less';
    return (
      this.state.data[index] ? (
        <tr key={index} >
          <td>
            <input type="text" style={{ width: "80%" }} value={this.state.data[index].Name} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index];
              obj.Name = event.target.value;
              data[index] = obj;
              this.setState({ data })
            }} />
          </td>
          <td>
            <div style={{ width: "100%" }}>
              <DropdownButton
                title={this.state.data[index].Value}
                bsSize="small"
                id={`dropdown-size-${index}`}
              >
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="DEFAULT">0. DEFAULT</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="CASH, GOLD, AND GEMSTONES">1. CASH, GOLD, AND GEMSTONES</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="ORIGINAL COST OF TANGIBLE ASSETS">2. ORIGINAL COST OF TANGIBLE ASSETS</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="ACCUMULATED AMORTIZATION OF TANGIBLE ASSETS">3. ACCUMULATED AMORTIZATION OF TANGIBLE ASSETS</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="ORIGINAL COST OF FIXED ASSET FINANCING">4. ORIGINAL COST OF FIXED ASSET FINANCING</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="ACCUMULATED AMORTIZATION OF FIXED ASSETS FINANCING">5. ACCUMULATED AMORTIZATION OF FIXED ASSETS FINANCING</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="ORIGINAL COST OF INTANGIBLE FIXED ASSETS">6. ORIGINAL COST OF INTANGIBLE FIXED ASSETS</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="ACCUMULATED AMORTIZATION OF INTANGIBLE ASSETS">7. ACCUMULATED AMORTIZATION OF INTANGIBLE ASSETS</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="RECEIVABLES">8. RECEIVABLES</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="OTHER ASSETS">9. OTHER ASSETS</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="REFUND ENTERPRISE INCOME TAX ASSETS">10. REFUND ENTERPRISE INCOME TAX ASSETS</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={(eventKey, event) => { this.handleSelectAssetCode(index, eventKey, event); }} eventKey="RISK PROVISIONS FOR OTHER ASSETS">11. RISK PROVISIONS FOR OTHER ASSETS</MenuItem>
              </DropdownButton>
            </div>
          </td>
          <td>
            <i className={classNameLessIcon} style={{ fontSize: 27, cursor: 'pointer' }} onClick={() => { return this.onRemoveItem(index); }} />

            <i className={classNameAddIcon} style={{ fontSize: 27, cursor: 'pointer' }} onClick={() => { return this.onAddItem(index); }} />
          </td>
        </tr>
      ) : (
        <tr key={index} >
          <td>
            <input type="text" style={{ width: "80%" }} value={''} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index];
              obj.Name = event.target.value;
              data[index] = obj;
              this.setState({ data })
            }} />
          </td>
          <td>
            <input type="text" min="0" max="100" style={{ width: "50%" }} value={0} onChange={(event) => {
              const data = JSON.parse(JSON.stringify(this.state.data));
              const obj = data[index];
              obj.Value = event.target.value;
              data[index] = obj;
              this.setState({ data })
            }} />
          </td>
          <td>
            <i className={classNameLessIcon} style={{ fontSize: 27, cursor: 'pointer' }} onClick={() => { return this.onRemoveItem(index); }} />

            <i className={classNameAddIcon} style={{ fontSize: 27, cursor: 'pointer' }} onClick={() => { return this.onAddItem(index); }} />
          </td>
        </tr>
      )
    );
  };

  render() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    const listRender = []
    this.state.data.forEach(e => {
      listRender.push(this.renderRow(e.Index, e.IsLastItem));
    })

    return (
      <div className="card">
        <div className="header">
          <h4 className="title">Other Assets</h4>
          <div style={{ width: '100%' }}>
            <button type="button" className="btn btn-primary" style={{ marginRight: 2 }} onClick={() => {
              this.onUpdateData();
            }}>Update</button>
            <button type="button" className="btn btn-primary" onClick={() => {
              this.onCancel();
            }}>Cancel</button>
          </div>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width" style={{ overflowX: "unset" }}>
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Value</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {listRender}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/MasterTable/OtherAsset.js